// Mecha design theme standard colours and variables.

const mechaColours = {
    backgroundPrimary: 'rgba(233, 242, 251, 1)',
    buttonHero: 'rgba(245, 209, 85, 1)',
    buttonHeroHover: 'rgba(240, 229, 153, 1)',
    buttonHeroPressed: 'rgba(240, 229, 153, 1)',
    buttonWhiteHero: 'rgba(255, 255, 255, 1)',
    buttonWhiteHeroHover: 'rgba(240, 229, 153, 1)',
    buttonWhiteHeroPressed: 'rgba(240, 229, 153, 1)',
    buttonBackgroundDisabled: 'rgba(236, 235, 235, 1)',
    buttonContentDisabled: 'rgba(173, 168, 166, 1)',
    borderPrimary: 'rgba(0, 20, 100, 1)',
    backgroundWhite: 'rgba(255, 255, 255, 1)',
    lightBlue300: 'rgba(180, 212, 248, 1)',
    primaryDarkBlue: 'rgba(0, 20, 100, 1)',
    primaryMediumBlue: 'rgba(15, 88, 171, 1)',
    primary500: 'rgba(11, 96, 183, 1)',
    greyDisabledText: 'rgba(173, 168, 166, 1)',
    greyscale400: 'rgba(64, 71, 86, 1)',
    greyscale800: 'rgba(38, 45, 59, 1)',
    redMain: 'rgba(185, 30, 40, 1)',
    error50: 'rgba(251, 237, 238, 1)',
    error100: 'rgba(251, 228, 230, 1)',
    error500: 'rgba(210, 32, 47, 1)',
    contentPrimary: 'rgba(0, 20, 100, 1)',
    linkPrimary: 'rgba(15, 88, 171, 1)',
    linkSecondary: 'rgba(0, 20, 67, 1)',
    buttonTextHover: 'rgba(233, 242, 251, 1)',
    buttonTextPressed: 'rgba(180, 212, 248, 1)',
    primaryTextColor: 'rgba(255, 255, 255, 1)',
    yellow200: '#F5D155'
};

export { mechaColours };
